<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <b-img class="arvas-logo" :src="arvasLogo"/>
      </b-link>
      <b-col lg="8" class="d-none d-lg-flex align-items-center pl-0 pr-0">
        <!-- <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"> -->
        <b-img fluid :src="bigImage"/>
        <!-- </div> -->
      </b-col>
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto login-root">
          <div class="d-flex justify-content-center mb-3">
            <b-img class="oys-logo" :src="oysLogo"/>
          </div>
          <hr/>
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Firma Kodu</label>
                </div>
                <validation-provider #default="{ errors }">
                  <b-form-input
                      v-model="kurumKodu"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Firma Kodu"
                      ref="focusMe"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Kullanıcı Adı</label>
                </div>
                <validation-provider #default="{ errors }">
                  <b-form-input
                      v-model="user"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Kullanıcı Adı"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Şifre</label>
                </div>
                <validation-provider #default="{ errors }">
                  <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                        id="login-password"
                        v-model="pwd"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  name="checkbox-1"
                  v-model="beniHatirla"
                >
                  Beni Hatırla
                </b-form-checkbox>
              </b-form-group> -->
              <!-- submit buttons -->
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  type="submit"
                  variant="info"
                  block
                  @click="logIn()"
              >
                Oturum Aç
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      beniHatirla: '',
      pwd: '',
      kurumKodu: '',
      user: '',
      oysLogo: require('@/assets/images/restoran/logo/oys-3.png'),
      arvasLogo: require('@/assets/images/restoran/logo/arvas.png'),
      bigImage: require('@/assets/images/restoran/login/macos.jpg'),
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
  },
  mounted() {
    this.$refs.focusMe.focus()
  },
  methods: {
    logIn() {
      this.$store
          .dispatch('logIn', {
            firmaKodu: this.kurumKodu,
            user: this.user,
            pwd: this.pwd,
          })
          .then((res, position = 'bottom-right') => {
            if (res.status === 200) {
              if (store.state.role === 'pc' || store.state.role === 'tablet') {
                this.$router.push('/')
              } else if (store.state.role === 'mutfak') {
                this.$router.push('/mutfak')
              }
              this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: 'Sisteme Hoşgeldiniz',
                      text: 'Öğretmenevi Yönetim Sistemi',
                      icon: 'ThumbsUpIcon',
                      variant: 'success',
                    },
                  },
                  { position },
              )
            }
          })
          .catch(err => {
            if (err !== 'moduleError') {
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: 'Hata!',
              //     text: err.errMsg,
              //     icon: 'ThumbsDownIcon',
              //     variant: 'danger',
              //   },
              // })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Hata!',
                  text: 'Geçersiz Modül',
                  icon: 'ThumbsDownIcon',
                  variant: 'danger',
                },
              })
            }
          })
    },
  },
}
</script>

<style scoped>
.auth-inner {
  overflow-y: hidden !important;
}

.img-fluid {
  max-width: 120%;
  height: auto;
}

.oys-logo {
  width: 230px !important;
}

.arvas-logo {
  width: 150px !important;
  background-color: transparent !important;
}

.login-root {
  margin-bottom: 110px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
